import AboutUs from './AboutUs.jsx';

export default AboutUs;
